<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <v-row justify="space-between">
        <v-col cols="12" sm="10" md="6">
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Od"
                :date="startDate"
                :time="startTime"
                @change="updateStartDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Do"
                :date="endDate"
                :time="endTime"
                @change="updateEndDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="electronicDevicesWithNull"
                item-text="name"
                item-value="val"
                v-model="electronicDevice"
                label="Blagajna"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="auto">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="search"
              >
                Išči
                <v-icon right dark>fas fa-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-btn
                v-if="!loading && reportData.length"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="print"
              >
                Tiskaj
                <v-icon right dark>fas fa-print</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-btn
                v-if="!loading && reportData.length"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="daily_sell_report_pdf_print"
              >
                PRIKAŽI PDF
                <v-icon right dark>fas fa-print</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-btn
                v-if="!loading && reportData.length"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="showDetails = !showDetails"
              >
                {{detailsBtnTxt}}
                <v-icon right dark>fas fa-info</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" v-show="loading">
          <AppSpinner />
        </v-col>
        <v-col cols="12" v-show="!loading && totalsDevices.length && !showDetails">
          <ReportDailyTotalsRow :totalSum="totalSum" :devices="totalsDevices" />
          <ReportDailyDayRow :day="day" v-for="day in daily" :key="day.date" />
        </v-col>
        <v-col cols="12" v-show="!loading && totalsDevices.length && showDetails">
          <ReportDailyTotalsDetailsRow :data="reportData" :params="params" />
          <ReportDailyDayDetailsRow :day="day" v-for="day in daily" :key="day.date" />
        </v-col>
      </v-row>
    </div>

    <div class="print">
      <ReportPrintDaily :data="reportData" :params="params" v-if="reportData" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateTimeSelector from '@/components/DateTimeSelector'
import ReportDailyDayRow from '@/components/ReportDailyDayRow'
import ReportDailyTotalsRow from '@/components/ReportDailyTotalsRow'
import ReportDailyDayDetailsRow from '@/components/ReportDailyDayDetailsRow'
import ReportDailyTotalsDetailsRow from '@/components/ReportDailyTotalsDetailsRow'
import ReportPrintDaily from '@/components/ReportPrintDaily'

export default {
  components: {
    AppSpinner: () => import('@/components/AppSpinner'),
    ReportPrintDaily,
    DateTimeSelector,
    ReportDailyDayRow,
    ReportDailyTotalsRow,
    ReportDailyDayDetailsRow,
    ReportDailyTotalsDetailsRow
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      electronicDevicesWithNull: [],
      electronicDevice: null,
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      reportData: [],
      loading: false,
      showDetails: false
    }
  },
  computed: {
    detailsBtnTxt () {
      return this.showDetails ? 'Skrij podrobnosti' : 'Pokaži podrobnosti'
    },
    electronicDevices () {
      return Object.values(this.$store.state.devices.items)
    },
    params () {
      return {
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime,
        type: 'DAILY',
        electronicDevice: this.electronicDevice
      }
    },
    totalsDevices () {
      return this.dailySummed
    },
    daily () {
      let days = {}
      this.reportData.forEach(device => {
        days = addDeviceToDays(device, days)
      })
      return Object.values(days).sort((a, b) => a.date > b.date ? 1 : -1)
    },
    totalSum () {
      return this.dailySummed.reduce((total, device) => total + device.total, 0)
    },
    dailySummed () {
      const summed = {}
      this.daily.forEach(day => {
        Object.values(day.devices).forEach(device => {
          if (summed[device.name]) {
            const taxLevels = summed[device.taxLevels] || {}
            Object.keys(device.taxLevels).forEach(taxLevelValue => {
              taxLevels[taxLevelValue] = {
                taxable_amount: taxLevels[taxLevelValue] && taxLevels[taxLevelValue].taxable_amount ? taxLevels[taxLevelValue].taxable_amount + device.taxLevels[taxLevelValue].taxable_amount : device.taxLevels[taxLevelValue].taxable_amount,
                tax_amount: taxLevels[taxLevelValue] && taxLevels[taxLevelValue].tax_amount ? taxLevels[taxLevelValue].tax_amount + device.taxLevels[taxLevelValue].tax_amount : device.taxLevels[taxLevelValue].tax_amount
              }
            })
            summed[device.name] = {
              date: device.date,
              maxInvoiceNumber: summed[device.name].maxInvoiceNumber > device.maxInvoiceNumber ? summed[device.name].maxInvoiceNumber : device.maxInvoiceNumber,
              minInvoiceNumber: summed[device.name].minInvoiceNumber < device.minInvoiceNumber ? summed[device.name].minInvoiceNumber : device.minInvoiceNumber,
              name: device.name,
              taxLevels,
              tax_amount_total: summed[device.name].tax_amount_total + device.tax_amount_total,
              taxable_amount_total: summed[device.name].taxable_amount_total + device.taxable_amount_total,
              total: summed[device.name].total + device.total
            }
          } else {
            summed[device.name] = device
          }
        })
      })
      return Object.values(summed)
    }
  },
  methods: {
    ...mapActions('devices', { loadDevices: 'loadItems' }),
    ...mapActions('reports', ['generateReport', 'updatePrintData']),
    daily_sell_report_pdf_print () {
      const dateFrom = moment(`${this.params.startDate} ${this.params.startTime}:00`).format('YYYY-MM-DDTHH:mm:ss')
      const dateTo = moment(`${this.params.endDate} ${this.params.endTime}:59`).format('YYYY-MM-DDTHH:mm:ss')
      const apiParams = { dateFrom, dateTo }
      if (this.params.electronicDevice) {
        apiParams.electronicDevice = this.params.electronicDevice
      } else {
        apiParams.businessUnit = this.$store.state.businessUnits.currentBusinessUnit.id
      }

      let routeData = this.$router.resolve({ name: 'MyCompanyReportsDailyPreview', query: apiParams })
      window.open(routeData.href, '_blank')
    },
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    },
    search () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.reportData = []
        this.generateReport(this.params)
          .then(response => {
            this.loading = false
            if (response) {
              this.reportData = response
              resolve()
            }
          })
          .catch(anErr => {
            this.loading = false
            this.$notify({
              type: 'error',
              text: 'Prišlo je do napake pri generiranju izpisa.'
            })
            resolve()
          })
      })
    },
    print () {
      // let routeData = this.$router.resolve({ name: 'MyCompanyReportsPrint', query: { params: JSON.stringify(this.params) } })
      // window.open(routeData.href, '_blank')
      window.print()
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      const today = moment().format('YYYY-MM-DD')
      this.startDate = today
      this.endDate = today
      this.loadDevices()
        .then(response => {
          this.electronicDevicesWithNull.push({
            name: 'Vse naprave',
            val: null
          })
          this.electronicDevices.forEach(device => {
            this.electronicDevicesWithNull.push({
              name: `${device.name} (${device.electronic_device_id})`,
              val: device.id
            })
          })
          this.search()
            .then(() => {
              this.asyncDataStatus_fetched()
            })
        })
        .catch(anErr => {
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri nalaganju podatkov.'
          })
        })
    }
  },
  watch: {
    /* startDate: {
      handler (newVal) {
        if (newVal) this.search()
      },
      immediate: true
    },
    startTime (newVal) {
      if (newVal) this.search()
    },
    endDate (newVal) {
      if (newVal) this.search()
    },
    endTime (newVal) {
      if (newVal) this.search()
    },
    electronicDevice () {
      this.search()
    } */
  }
}

const addDeviceToDays = (device, days) => {
  device.daily.forEach(day => {
    if (!days[day.date]) {
      days[day.date] = {
        date: day.date
      }
    }
    if (!days[day.date].devices) {
      days[day.date].devices = {}
    }
    const taxLevels = {}
    day.taxGroups.taxLevels.forEach(level => {
      taxLevels[level.tax_level_value] = {
        taxable_amount: taxLevels[level.tax_level_value] && taxLevels[level.tax_level_value].taxable_amount ? taxLevels[level.tax_level_value].taxable_amount + level.taxable_amount : level.taxable_amount,
        tax_amount: taxLevels[level.tax_level_value] && taxLevels[level.tax_level_value].tax_amount ? taxLevels[level.tax_level_value].tax_amount + level.tax_amount : level.tax_amount
      }
    })
    days[day.date].devices[device.name] = {
      date: day.date,
      name: device.name,
      minInvoiceNumber: day.minInvoiceNumber,
      maxInvoiceNumber: day.maxInvoiceNumber,
      taxable_amount_total: day.taxGroups.taxable_amount_total,
      tax_amount_total: day.taxGroups.tax_amount_total,
      total: day.totalSum,
      taxLevels
    }
  })
  return days
}
</script>

<style lang="scss" scoped>
.print {
  display: none;
}
@media print {
  .print {
    display: block;
  }
}
</style>

<style lang="scss">
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>
